/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFileMagnifyingGlass: {
  name: 'file-magnifying-glass';
  data: string;
} = {
  name: 'file-magnifying-glass',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 2A1.5 1.5 0 0 1 4 .5h4.586a1.5 1.5 0 0 1 1.06.44l3.415 3.414a1.5 1.5 0 0 1 .439 1.06V6a.5.5 0 0 1-1 0v-.5H10A1.5 1.5 0 0 1 8.5 4V1.5H4a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1H4A1.5 1.5 0 0 1 2.5 14V2Zm7 .207V4a.5.5 0 0 0 .5.5h1.793L9.5 2.207ZM8.5 11a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM11 7.5a3.5 3.5 0 1 0 2.1 6.3c.014.019.03.037.046.054l1.5 1.5a.5.5 0 0 0 .708-.708l-1.5-1.5a.515.515 0 0 0-.054-.046A3.5 3.5 0 0 0 11 7.5Z" fill="currentColor"/></svg>`,
};
